<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <div class="divContainer">
          <div class="card">
            <div class="card-body">
              <button type="button" id="btnLoadList" (click)="getjournalmappingList()" style="display:none">Get</button>
              <button type="button" id="btn_AddNew" class="btn btn-block btn-primary float-sm-right" (click)="show()" style="display:none">Add New</button>
              <button type="button" id="btnColSave" class="btn btn-block btn-primary float-sm-right" style="display:none">Columns</button>
              <button type="button" id="btnDeleteDT" (click)="Delete()" style="display:none">Delete</button>
              <button type="button" id="btnDeleteConfirm" (click)="DeleteConfirm()" style="display:none">Delete Confirm</button>

              <table #dataTable class="display" style="width:100%"></table>
            </div>
          </div>
        </div>

        <!-- The Modal -->
        <div class="modal" id="myModal" [style.display]="showModal ? 'block' : 'none'">
          <div class="modal-dialog modal-lg">
            <div class="modal-content" id="divJrnlConfigCT">

              <!-- Modal Header -->
              <div class="modal-header">
                <h4 class="modal-title">{{ title }}</h4>
                <button type="button" class="close" data-dismiss="modal" (click)="hide()">&times;</button>
              </div>

              <div class="row" id="divFormPanel">

                <!-- Modal body -->
                <div class="modal-body">
                  <form #form="ngForm" id="frmJrnlConfig">
                    <div class="col-sm-12">
                      <div class="row">
                        <div class="col-4">
                          <div class="form-group">
                            <label for="txtJournalCode" class="control-label">Journal Code<em>*</em></label>
                            <input class="form-control" type="text" maxlength="15" id="txtJournalCode">
                          </div>
                        </div>
                        <div class="col-4">
                          <div class="form-group">
                            <label for="ddlJournalType">Journal Type<em>*</em></label>
                            <select id="ddlJournalType" class="form-control">
                              <option value="Open Access" selected="selected">Open Access</option>
                              <option value="Non-Open Access">Non-Open Access</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-4">
                          <div class="form-group">
                            <label for="ddlAllocationType">Allocation Type<em>*</em></label>
                            <select id="ddlAllocationType" class="form-control">
                              <option value="Single" selected="selected">Single</option>
                              <option value="Alternate">Alternate(Odd/Even)</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="form-group">
                            <label for="txtJournalName" class="control-label">Journal Title<em>*</em></label>
                            <input class="form-control" type="text" maxlength="500" id="txtJournalName">
                          </div>
                        </div>
                      </div>
                      <div class="row">

                        <div class="col-12">
                          <div class="form-group">
                            <label for="ddlPrimaryUser">Primary User<em>*</em></label>
                            <select id="ddlPrimaryUser" class="form-control">
                              <option *ngFor="let item of UserList" value={{item.UserID}}>
                                {{item.LoginName}}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="form-group">
                            <label for="ddlSecondUser">Backup User<em>*</em></label>
                            <select id="ddlSecondUser" class="form-control">
                              <option *ngFor="let item of UserList" value={{item.UserID}}>
                                {{item.LoginName}}
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <!-- Modal footer -->
                <div class="modal-footer">
                  <button type="button" class="btn btn-info waves-effect waves-light" data-dismiss="modal" (click)="hide()">Close</button>
                  <button type="button" class="btn btn-success waves-effect waves-light" (click)="updateJournalConfigDetails()">Update</button>
                </div>
              </div>
              <div id="LoadingImagePopup">
                <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loading" />
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
